module.exports = function (product, options) {
  if (product.properties._availabilityFulfilment === 'Digital' || product.properties.Delivery === 'Digital') {
    return options.fn(this);
  }
  return options.inverse(this);
};
